export default function convertDate(inputDate) {
  if (!inputDate) {
    return "";
  }
  var options = { year: "numeric", month: "long", day: "numeric" };
  const date = new Date(inputDate);
  return `${date.toLocaleDateString("en-US", options)}`;
}
